import { Component,  Inject,  Input } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Program, Session } from 'globals/store/programs.data';
import { Wrapper } from '../../components/wrapper.component';
import { sessionReselector } from '../../store/reselectors/sessions.reselector';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { EditCueColumnsComponent } from './edit-cue-columns.component';
import { CueSheetComponent } from './cue-sheet.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'cue-sheet-dialog',
    template: `
<wide-dialog-wrapper
  [dialogTitle]="'Edit Run of Show'"
  [backgroundColor]="'#A6DBFF'"
  [disabled]="data.readOnly"
  [delete]="false"
  [successLabel]="'DONE'"
  (onSubmit)="dialogRef.close()"
>
  <edit-cue-columns [programId]="program.id"></edit-cue-columns>
  <cue-sheet *ngIf="!!session && !!program" [session]="session" [program]="program"></cue-sheet>
</wide-dialog-wrapper>

`,
    styles: [`
    cue-sheet { margin: 0px 40px 40px; }
    edit-cue-columns { display: flex; justify-content: end; margin: 20px; }
    :host ::ng-deep wide-dialog-wrapper .mat-button.mat-primary { margin: 0 20px 0 0 !important; }
  `],
    standalone: true,
    imports: [BigDialogWrapperComponent, MatButtonModule, CommonModule, EditCueColumnsComponent, CueSheetComponent]
})
export class CueSheetDialogComponent extends Wrapper<CueSheetDialogComponent> {
  session: Session
  program: Program
  constructor(public dialogRef: MatDialogRef<CueSheetDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageCueSheetData) {
    super()
    this.subProp(this.store.select('programs', 'entities', data.programId), 'program')
    this.selectProp(sessionReselector, data.sessionId, 'session')
  }
}

export interface ManageCueSheetData {
  sessionId: string
  programId: string
  readOnly: boolean
}



